import { RequestHeaders } from '@/@types/auth.types';
import { ApiConfig } from '@/config/api.config';
import { create } from "zustand";

type CurrencyState = {
    currencies: {
        USD: string;
        GEL: string;
    };
    currentCurrency?: keyof CurrencyState["currencies"];
    getCurrencies: () => CurrencyState["currencies"];
    getCurrentCurrency: () => keyof CurrencyState["currencies"] | undefined;
    setCurrentCurrency: (currency: keyof CurrencyState["currencies"]) => void;
};

export const useCurrencyStore = create<CurrencyState>((set, get) => ({
    currencies: {
        USD: '$',
        GEL: '₾',
    },
    currentCurrency: undefined,
    getCurrencies: () => get().currencies,
    getCurrentCurrency: () => get().currentCurrency,
    setCurrentCurrency: (currency) => {
        ApiConfig.axiosInstance.defaults.headers[RequestHeaders.Currency] = currency;
        set(() => ({ currentCurrency: currency }));
    },
}));
